module.exports = __webpack_public_path__ + "media/images/importante-953d749d1c114374b4aabaeb480321e0.svg";